// extracted by mini-css-extract-plugin
export default {"inputWrapper":"LabeledInput_inputWrapper__FJM-R","label":"LabeledInput_label__0187J","inputField":"LabeledInput_inputField__Tll0f","isDisabled":"LabeledInput_isDisabled__ZGFwd"};